module.exports = __webpack_public_path__ + "img/b_2.926a5d59.png";